<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-2"
                                            v-on:click="searchListing"
                                            v-b-tooltip.hover
                                            :title="$t('label.refresh')"
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.company') }}
                                                </label>
                                                <multiselect
                                                    v-model="companyFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="companyDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">User type</label>
                                                <multiselect
                                                    v-model="userTypeFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="userTypeDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="primary"
                                            class="mr-1"
                                            v-on:click="openExternalForm"
                                            v-b-tooltip.hover
                                            title="Create external user"
                                        >
                                            <i class="mdi mdi-exit-to-app"></i>
                                        </b-button>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(userType)="data">
                                    <i v-if="data.item.userType == 1" class="mdi mdi-account-arrow-right-outline text-success font-size-20" v-b-tooltip.hover title="External user"></i>
                                    <i v-else-if="data.item.userType == 0" class="mdi mdi-account-tie-outline text-info font-size-20" v-b-tooltip.hover title="Internal user"></i>
                                </template>
                                <template #cell(fullName)="data">
                                    <div class="d-flex align-items-center">
                                        <img
                                            v-if="tableRows[data.index].image"
                                            :src="tableRows[data.index].image"
                                            v-on:click.stop="openImageModal(tableRows[data.index])"
                                            class="mr-2 cursor-pointer"
                                            style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;"
                                        />
                                        <i
                                            v-else
                                            class="mdi mdi-account-circle mr-2"
                                            style="font-size: 30px; line-height: 02px;"
                                        ></i>
                                        <span>
                                            {{ tableRows[data.index].firstName }} {{ tableRows[data.index].lastName }}
                                        </span>
                                    </div>
                                </template>
                                <template #cell(phone)="data">
                                    {{ tableRows[data.index].phone ? (tableRows[data.index].phoneCode ?? '')+ ' ' + tableRows[data.index].phone : '--' }}
                                </template>
                                <template #cell(company)="data">
                                    <CompanyLink :company="data.item.userCompanies?.[0]?.company" fallback="--" />
                                    <template v-if="tableRows[data.index]?.userCompanies?.length > 1">
                                        <i
                                            :id="'company-popover-' + data.index"
                                            class="mdi mdi-information-outline ml-1"
                                        ></i>
                                        <b-popover
                                            :target="'company-popover-' + data.index"
                                            triggers="hover focus"
                                            placement="right"
                                            custom-class="company-popover shadow-lg border border-light"
                                        >
                                            <div
                                                v-for="(item, index) in tableRows[data.index].userCompanies"
                                                :key="index"
                                                class="py-1"
                                                :class="{ 'border-bottom': index !== tableRows[data.index].userCompanies.length - 1 }"
                                            >
                                                <i class="mdi mdi-circle-small mr-1"></i><CompanyLink :company="item.company" />
                                            </div>
                                        </b-popover>
                                    </template>
                                </template>
                                <template #cell(access)="data">
                                    <span
                                        :class="[ 'badge mr-1', data.item.appAccess == 1 ? 'badge-info' : data.item.appAccess == 2 ? 'badge-warning' : 'badge-secondary']"
                                        :title="data.item.appAccess == 1 ? $t('label.active') : data.item.appAccess == 2 ? $t('label.pending') : $t('label.inactive')"
                                        v-b-tooltip.hover
                                    >
                                        <i :class="['mdi mr-1', data.item.appAccess == 1 ? 'mdi-check' : data.item.appAccess == 2 ? 'mdi-alert-circle-outline' : 'mdi-close']"></i>
                                        {{ $t('label.app') }}
                                    </span>
                                    <span
                                        :class="['badge', data.item.portalAccess == 1 ? 'badge-info' : data.item.portalAccess == 2 ? 'badge-warning' : 'badge-secondary']"
                                        :title="data.item.portalAccess == 1 ? $t('label.active') : data.item.portalAccess == 2 ? $t('label.pending') : $t('label.inactive')"
                                        v-b-tooltip.hover
                                    >
                                        <i :class="['mdi mr-1', data.item.portalAccess == 1 ? 'mdi-check' : data.item.portalAccess == 2 ? 'mdi-alert-circle-outline' : 'mdi-close']"></i>
                                        {{ $t('label.portal') }}
                                    </span>
                                </template>
                                <template #cell(loginAttempt)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].appLoginAttempt == 3 ? 'danger' : 'success'"
                                        v-b-tooltip.hover
                                        :title="tableRows[data.index].appLoginAttempt == 3 ? $t('label.locked') : $t('label.active')"
                                        class="mr-1"
                                    >
                                        <i :class="['mdi', tableRows[data.index].appLoginAttempt == 3 ? 'mdi-lock' : 'mdi-check']"></i> {{ $t('label.app') }}
                                    </b-badge>
                                    <b-badge
                                        :variant="tableRows[data.index].portalLoginAttempt == 3 ? 'danger' : 'success'"
                                        v-b-tooltip.hover
                                        :title="tableRows[data.index].portalLoginAttempt == 3 ? $t('label.locked') : $t('label.active')"
                                    >
                                        <i :class="['mdi', tableRows[data.index].portalLoginAttempt == 3 ? 'mdi-lock' : 'mdi-check']"></i> {{ $t('label.portal') }}
                                    </b-badge>
                                </template>
                                <template #cell(appLastLogin)="data">
                                    <b-badge
                                        v-if="tableRows[data.index].appLastLoginAt"
                                        variant="primary"
                                        v-b-tooltip.hover
                                        :title="$t('label.appLastLogin')"
                                        class="mr-1"
                                    >
                                        {{ tableRows[data.index].appLastLoginAt }}
                                    </b-badge>
                                    <span v-else>--</span>
                                </template>
                                <template #cell(portalLastLogin)="data">
                                    <b-badge
                                        v-if="tableRows[data.index].portalLastLoginAt"
                                        variant="primary"
                                        v-b-tooltip.hover
                                        :title="$t('label.portalLastLogin')"
                                    >
                                        {{ tableRows[data.index].portalLastLoginAt }}
                                    </b-badge>
                                    <span v-else>--</span>
                                </template>
                                <template #cell(status)="data">
                                    <b-badge
                                        :variant="tableRows[data.index].isActive ? 'success' : 'secondary'"
                                    >
                                        {{ tableRows[data.index].isActive ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <b-button variant="link" class="text-info p-0 mr-1" :to="{ name: 'UserDetails', params: { userUUID: data.item.uuid } }" :title="$t('label.viewX', [$t('module.user')])" :aria-label="$t('label.viewX', [$t('module.user')])"><i class="mdi mdi-eye-outline font-size-18"></i></b-button>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-warning ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.unlockAccount')"
                                        v-on:click="unlockConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-key`]"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-danger ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.deleteX', [$t('label.permanently')])"
                                        v-on:click="deletePermanentlyConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-account-off`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="user-external-form"
            :title="externalUserUUID ? 'Update external user' : 'Create external user'"
            @hidden="closeExternalForm"
            hide-footer
            hide-header-close
            centered
            size="xl"
            :no-close-on-backdrop="!status.save"
            :no-close-on-esc="!status.save"
        >
            <b-container fluid>
                <UserFormExternal
                    v-if="showExternalForm"
                    :userUUID="externalUserUUID"
                    :searchCriteria="searchCriteria"
                    @done="closeExternalForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="user-form"
            :title="$t(user.uuid ? 'label.updateX' : 'label.createX', [$t('module.state')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
            size="xl"
        >
            <b-container fluid>
                <UserForm
                    :userUUID="user.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="userForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="user-delete"
            :title="user.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ user.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('user-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ user.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="user-unlock"
            :title="$t('label.unlockAccount')"
            @hidden="closeForm"
            hide-header-close
            centered
        >
            <b-container fluid>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group
                            :label="$t('label.appAccess')"
                            label-cols="7"
                            label-align="left"
                        >
                            <b-form-checkbox
                                v-model="user.isApp"
                                class="mt-2"
                            ></b-form-checkbox>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            :label="$t('label.portalAccess')"
                            label-cols="7"
                            label-align="left"
                        >
                            <b-form-checkbox
                                v-model="user.isPortal"
                                class="mt-2"
                            ></b-form-checkbox>
                        </b-form-group>
                    </div>
                </div>
            </b-container>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('user-unlock')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestUnlock"
                    :disabled="!status.save"
                >
                    {{ $t('label.unlock') }}
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="user-delete-permanently"
            :title="$t('label.deleteX', [$t('label.permanently')])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ $t('message.thisUserWillBeDeletedPermanently') }}</p>
            <p class="my-4">{{ $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('user-delete-permanently')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDeletePermanently"
                    :disabled="!status.save"
                >
                    {{ $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="user-image"
            :title="$t('label.viewX', [$t('label.image')])"
            @hidden="closeForm"
            centered
            size="lg"
            hide-header-close
        >
            <b-container fluid>
                <div class="col-12">
                    <div class="row d-flex justify-content-center border border-light shadow-lg m-1 p-3 rounded">
                        <img
                            :src="user.image"
                            style="max-width: 100%; max-height: 600px;"
                        />
                    </div>
                </div>
            </b-container>
            <template #modal-footer>
                <b-button
                    variant="danger"
                    class="col-2"
                    @click="$bvModal.hide('user-image')"
                >
                    {{ $t('label.cancel') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { userMethods, lookupMethods } from "@/state/api";
import { USER_MODULE } from "@/state/api/user.state";
import UserFormExternal from "@/views/pages/admin/user/userFormExternal";
import UserForm from "@/views/pages/admin/user/userForm";

export default {
    components: { Multiselect, UserForm, UserFormExternal },
    async created() {
        await this.lookupCompany({});

        sessionHelper.clearSearch(SESSION.USER_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            showExternalForm: false,
            externalUserUUID: "",
            userTypeFilter: { value: null, text: i18n.t('label.all') },
            userTypeDdl: [
                { value: null, text: i18n.t('label.all') },
                { value: 0, text: 'Internal' },
                { value: 1, text: 'External' },
            ],
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            companyFilter: null,
            fields: [
                { key: 'fullName', label: i18n.t("label.name"), sortable: true, class: 'text-nowrap' },
                { key: 'email', label: i18n.t("label.email"), sortable: true, class: 'text-nowrap' },
                { key: 'phone', label: i18n.t("label.phone"), sortable: true, class: 'text-nowrap' },
                { key: 'company', label: i18n.t("module.company"), sortable: true, class: 'text-nowrap' },
                { key: 'userType', label: 'External user', sortable: false, class: 'text-nowrap text-center' },
                { key: 'appLastLogin', label: i18n.t("label.appLastLogin"), sortable: true, class: 'text-nowrap' },
                { key: 'portalLastLogin', label: i18n.t("label.portalLastLogin"), sortable: true, class: 'text-nowrap' },
                { key: 'loginAttempt', label: i18n.t("label.loginAccess"), sortable: false, class: 'text-nowrap' },
                { key: 'access', label: i18n.t("label.access"), sortable: false, class: 'text-nowrap' },
                { key: 'status', label: i18n.t("label.status"), sortable: false, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            user: {
                uuid: "",
                isActive: false,
                image: null,
                isApp: false,
                isPortal: false,
            },
            loading: true,
        };
    },
    methods: {
        ...userMethods,
        ...lookupMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.USER_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    companyUUID: null,
                    userType: this.userTypeFilter.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getUserList(this.searchCriteria);
        },
        getUserList(filter) {
            this.getAllUser({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.USER_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.USER_SEARCH);
            filter.pageNumber = pageNumber;
            this.getUserList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            this.searchCriteria.userType = this.userTypeFilter.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }

            if (this.companyFilter?.value == 1)
                delete this.searchCriteria.companyUUID;
            else if (this.companyFilter?.value)
                this.searchCriteria.companyUUID = this.companyFilter.value;

            this.getUserList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.user = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('user-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.user.uuid,
                isActive: this.user.isActive == 0 ? 1 : 0,
            };
            this.updateUserStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('user-delete');
                }));
        },
        unlockConfirmation(data) {
            this.user = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('user-unlock');
        },
        requestUnlock() {
            let data = {
                uuid: this.user.uuid,
                isPortal: this.user.isPortal,
                isApp: this.user.isApp,
            };
            this.unlockUser({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('user-unlock');
                }));
        },
        deletePermanentlyConfirmation(data) {
            if (data?.uuid) {
                this.user = {
                    uuid: data.uuid,
                };
            }
            this.$bvModal.show('user-delete-permanently');
        },
        requestDeletePermanently() {
            let data = {
                uuid: this.user.uuid,
            };
            this.softDeleteUser({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('user-delete-permanently');
                }));
        },
        openExternalForm(data) {
            this.externalUserUUID = data?.uuid || "";
            this.showExternalForm = true;
            this.$nextTick(() => this.$bvModal.show('user-external-form'));
        },
        closeExternalForm() {
            this.showExternalForm = false;
            this.externalUserUUID = "";
            this.$bvModal.hide('user-external-form');
        },
        openForm(data) {
            if (data?.userType == 1) {
                this.openExternalForm(data);
                return;
            }
            if (data?.uuid) {
                this.user = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('user-form');
            });
        },
        closeForm() {
            this.user = {
                uuid: "",
                isActive: false,
                image: null,
                isApp: false,
                isPortal: false,
            };
            this.$bvModal.hide('user-form');
        },
        openImageModal(data) {
            if (data?.image) {
                this.user = {
                    uuid: data.uuid,
                    image: data.image,
                };
                this.$bvModal.show('user-image');
            }  
        },
    },
    computed: {
        ...mapState(USER_MODULE, ['status']),
        companyDdl() {
            return [
                { value: 1, text: i18n.t('label.all') },
                ...this.$store.state.api.lookup.companyDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.user.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.user.list.pagination.total || 0;
        },
    },
}
</script>
<style>
.company-popover {
    min-width: 220px;
}
</style>
